import React, { useEffect } from "react";
import Footer from "../components/Footer";
import { languageData } from "../constants/languageData";
import Head from "./Head";
import RenderSvg from "../components/RenderSvg";
function JourneyStopped({reason}) {
  // let reason = "mobileAttemptsDone";

  // Guarded: sessionStorage may hold the literal "undefined" (branding-less flow),
  // which JSON.parse throws on — that must not white-screen the terminal page.
  let storedBranding = null;
  try {
    storedBranding = JSON.parse(sessionStorage.getItem("branding"));
  } catch (error) {
    storedBranding = null;
  }
  const language = sessionStorage.getItem("language") ?? "en";

  useEffect(() => {
    sessionStorage.removeItem("sessionId");
    sessionStorage.removeItem("jId");
    sessionStorage.removeItem("currentStep");
    sessionStorage.removeItem("redirectTime");
    sessionStorage.removeItem("companyLogo");
    sessionStorage.removeItem("language");
    sessionStorage.removeItem("document");
    sessionStorage.removeItem("ipAddress");
    sessionStorage.removeItem("selectedCountry");
    sessionStorage.removeItem("failureRedirectUrl");
    sessionStorage.removeItem("successRedirectUrl");
    sessionStorage.removeItem("documentFailureReason");
    sessionStorage.removeItem("currentStep");
  }, []);

  useEffect(() => {
    window.parent.postMessage("Invalid JourneyId", "*");
  }, []);

  return (
    <>
      <Head
        style={{ zIndex: "100" }}
        showBackIcon={false}
        showHelp={false}
        showMobileFlow={false}
        showLanguages={false}
      />
      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg
              config={{branding:{accentColor:storedBranding?.accentColor}}}
              id={"error"}
              svgType={"error"}
              className="md:w-[220px] md:h-[200px] w-[250px] h-[250px] md:relative "
              style={{ marginTop: "3rem" }}
            />
          </div>

          <div
            className="right-section md:items-start items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 24,
              fontFamily: "Inter, sans-serif",
              
            }}
          >
            <div className="flex flex-col md:text-start text-center items-start gap-4 self-stretch">
              <div className="text-black font-inter text-2xl font-semibold self-stretch text-[18px] md:text-[28px]">
                {
                (languageData[language]?.unableToProcess[reason] ||
                  languageData["en"]?.unableToProcess[reason])
                  ? languageData[language]?.unableToProcess[reason]
                      ?.heading ??
                    languageData["en"]?.unableToProcess[reason]?.heading
                  : languageData[language]?.unableToProcess
                      ?.heading ?? languageData["en"]?.unableToProcess?.heading}
              </div>
              <div className="text-[#656565] font-inter text-[12px] md:text-[16px] font-semibold leading-normal self-stretch">
                {
                (languageData[language]?.unableToProcess[reason] ||
                  languageData["en"]?.unableToProcess[reason])
                  ? languageData[language]?.unableToProcess[reason]
                      ?.subHeading ??
                    languageData["en"]?.unableToProcess[reason]?.subHeading
                  : languageData[language]?.unableToProcess
                      ?.subHeading ??
                    languageData["en"]?.unableToProcess?.subHeading}
              </div>
            </div>
            <div className="flex flex-col justify-center items-center w-full">              
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default JourneyStopped;
